import PT from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useStyles from './warning-dialog-styles';

function WarningDialog(props) {
  const {
    open,
    handleAccept,
    handleClose,
    title,
    body,
    primaryButtonText,
    secondaryButtonText,
  } = props;
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} className={classes.secondary}>
          {secondaryButtonText}
        </Button>
        <Button onClick={handleAccept} color="primary" autoFocus>
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

WarningDialog.propTypes = {
  open: PT.bool.isRequired,
  handleAccept: PT.func.isRequired,
  handleClose: PT.func.isRequired,
  title: PT.string.isRequired,
  body: PT.string.isRequired,
  primaryButtonText: PT.string.isRequired,
  secondaryButtonText: PT.string.isRequired,
};

export default WarningDialog;
